/**
 * Anchors the page to the plan results after a lookup without putting a hash in
 * the URL. The lookup form flags the submit and the results scroll into view
 * once the plans response has rendered.
 */
let pending = false;

export function requestResultsScroll() {
	pending = true;
}

export function scrollToResultsIfRequested() {
	if (!pending) return;
	pending = false;
	document.getElementById("product-result")?.scrollIntoView();
}
